var map = {
	"./big_smartsampa_logo_dark.png": 1023,
	"./big_smartsampa_logo_light.png": 1024,
	"./big_smartsampa_logo_lightAlt.png": 1025,
	"./big_smartsampa_logo_mobile_dark.png": 580,
	"./big_smartsampa_logo_mobile_light.png": 581,
	"./big_smartsampa_logo_mobile_lightAlt.png": 582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 337;